import { Component, OnInit, input, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { OktaWrapperService } from '@mysrc/services/framework/okta-wrapper.service';

@Component({
  selector: 'app-page-pb-login-v2',
  templateUrl: './page-pb-login-v2.component.html',
  styleUrls: ['./page-pb-login-v2.component.scss'],
  standalone: true,
  imports: [DatePipe]
})
export class PagePbLoginV2Component implements OnInit {

  /** App name/version shown in the sign-in panel foot. */
  public readonly appname = input<string>('');
  public readonly buildversion = input<string>('');

  /** Drives the live copyright year in the footer. */
  public readonly todaysDate = new Date();
  showLogin = signal(false);

  constructor(
    private oktaWrapper: OktaWrapperService,
    private router: Router
  ) { }

  async ngOnInit(): Promise<void> {
    const isAuthenticated = await this.oktaWrapper.isAuthenticated();

    if (isAuthenticated && !!this.oktaWrapper.getAccessToken()) {
      this.router.navigate(['home']).then(ok => {
        if (!ok) { this.showLogin.set(true); }   // if navigation fails, don't leave a blank page
      }).catch(() => this.showLogin.set(true));
      return;
    }
    this.showLogin.set(true);
  }

  public login(): void {
    this.oktaWrapper.login();
  }
}
